import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { Gift, ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import api from '../lib/api'

/**
 * Homepage akce — načte aktivní promo voucher z /promo a zobrazí lištu se slevou,
 * kódem a počtem zbývajících míst. Když žádná akce neběží (vyčerpáno/expirováno), nic nevykreslí.
 */
export default function PromoBanner() {
  const { t, i18n } = useTranslation()
  const { data } = useQuery({
    queryKey: ['homepage-promo', i18n.language],
    queryFn: () => api.get('/promo', { params: { lang: i18n.language } }).then((r) => r.data),
  })

  if (!data?.active) return null

  const discount = data.type === 'percent' ? `${Math.round(data.value)} %` : `${data.value} Kč`
  const plans = (data.plans?.length ? data.plans : ['starter', 'pro'])
    .map((p: string) => p.charAt(0).toUpperCase() + p.slice(1)).join(' / ')

  return (
    <Link
      to={`/pricing?promo=${encodeURIComponent(data.code)}`}
      className="group flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-gradient-to-r from-primary-600 to-cyan-500 text-white text-sm font-semibold px-4 py-2.5 text-center hover:opacity-95 transition"
    >
      <Gift className="w-4 h-4 shrink-0" />
      <span>
        {data.text || t('promo.text', { discount, plans, defaultValue: 'Akce: {{discount}} sleva na {{plans}} pro prvních 20 registrovaných' })}
      </span>
      {typeof data.remaining === 'number' && (
        <span className="bg-white/20 rounded-full px-2 py-0.5 text-xs">
          {t('promo.remaining', { n: data.remaining, defaultValue: 'zbývá {{n}} míst' })}
        </span>
      )}
      <span className="inline-flex items-center gap-1 underline underline-offset-2">
        {t('promo.code', { code: data.code, defaultValue: 'kód {{code}}' })}
        <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition" />
      </span>
    </Link>
  )
}
